import type {
  CardProjectDigitalDetailResponse,
  CardProjectDigitalDetailUpdateRequest,
  WCardProjectDigitalDetailView,
} from '@zola/svc-web-api-ts-client';

import ApiService from '../../util/api';

export const publishDigitalProject = ({
  projectUUID,
  accountId,
}: {
  projectUUID: string;
  accountId: string;
}): Promise<WCardProjectDigitalDetailView> => {
  const requestBody = {
    projectUUID,
    accountId,
  };
  return ApiService.post(`/web-api/v2/card-project/${projectUUID}/digital/publish`, requestBody);
};

export const fetchDigitalDetails = ({
  projectUUID,
}: {
  projectUUID: string;
}): Promise<CardProjectDigitalDetailResponse> => {
  return ApiService.get(`/web-api/v2/card-project/${projectUUID}/digital/details`);
};

export const saveDigitalDetails = ({
  projectUUID,
  request,
}: {
  projectUUID: string;
  request: CardProjectDigitalDetailUpdateRequest;
}): Promise<CardProjectDigitalDetailResponse> => {
  return ApiService.put(`/web-api/v2/card-project/${projectUUID}/digital/details`, request);
};

export const cloneDigitalProject = ({
  projectUUID,
  medium,
}: {
  projectUUID: string;
  medium: string;
}): Promise<any> => {
  const requestBody = {
    card_project_uuid: projectUUID,
    medium,
  };
  return ApiService.post(`/web-api/v2/card-project/${projectUUID}/clone/medium`, requestBody);
};

export const requestPublishedProjectRendering = ({ projectUUID }: { projectUUID: string }) => {
  const requestBody = {
    projectUUID,
  };
  return ApiService.post(`/web-api/v2/card-project/${projectUUID}/digital/render`, requestBody);
};

export const getProjectRenderingStatus = (requestUUID: string) => {
  const requestBody = {
    requestUUID,
  };
  return ApiService.get(
    `/web-api/v2/card-project/digital/render/${requestUUID}/status`,
    requestBody
  );
};

export const getPublishedProjectMediaImageUuid = ({ projectUUID }: { projectUUID: string }) => {
  const requestBody = {
    projectUUID,
  };
  return ApiService.get(`/web-api/v2/card-project/${projectUUID}/digital/render`, requestBody);
};
